"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Tag = _interopRequireDefault(require("../Tag"));
var _excluded = ["tags", "placeholder"];
var tagPropTypes = _Tag["default"].propTypes;
var tagPropType = tagPropTypes.tag;
var TagList = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var tags = _ref.tags,
    placeholder = _ref.placeholder,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (!tags || !tags.length) {
    return /*#__PURE__*/_react["default"].createElement(StyledPlaceholder, null, placeholder);
  }
  var uniqTags = (0, _uniq2["default"])(tags);
  return /*#__PURE__*/_react["default"].createElement(StyledTagList, props, uniqTags.map(function (tag) {
    return /*#__PURE__*/_react["default"].createElement(_Tag["default"], {
      as: "li",
      key: tag,
      tag: tag
    });
  }));
});
TagList.displayName = 'TagList';
TagList.propTypes = {
  className: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  tags: _propTypes["default"].arrayOf(tagPropType).isRequired
};
TagList.defaultProps = {
  className: '',
  placeholder: 'Укажите теги'
};
var StyledTagList = _styledComponents["default"].ul.withConfig({
  displayName: "TagList__StyledTagList",
  componentId: "sc-1i5xomu-0"
})(["display:flex;flex-wrap:wrap;font-size:12px;> li{display:inline;font-size:inherit;padding-right:5px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;}"]);
var StyledPlaceholder = _styledComponents["default"].span.withConfig({
  displayName: "TagList__StyledPlaceholder",
  componentId: "sc-1i5xomu-1"
})(["color:#919499;"]);
var _default = exports["default"] = TagList;